import Vue from 'vue'
import Vuetify, {
  VApp,
  VIcon,
  VCard,
  VSnackbar,
  VBtn,
  VChip,
  VSelect,
  VTextField,
  VTooltip,
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VApp,
    VIcon,
    VCard,
    VSnackbar,
    VBtn,
    VChip,
    VSelect,
    VTextField,
    VTooltip,
  },
  directives: {
    Ripple,
  },
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: {
          base: '#00acef', // 400
          lighten3: '#f3fafe', // 100
          lighten2: '#e9f7ff', // 200
          lighten1: '#cae8f8', // 300
          darken1: '#008acd', // 500
          darken2: '#005997', // 600
        },
        blue: {
          base: '#00acef', // 400
          lighten3: '#f3fafe', // 100
          lighten2: '#e9f7ff', // 200
          lighten1: '#cae8f8', // 300
          darken1: '#008acd', // 500
          darken2: '#005997', // 600
        },
        info: {
          base: '#00acef', // 400
          lighten3: '#f3fafe', // 100
          lighten2: '#e9f7ff', // 200
          lighten1: '#cae8f8', // 300
          darken1: '#008acd', // 500
          darken2: '#005997', // 600
        },
        secondary: '#1867c0',
        indigo: {
          base: '#3c3087', // 500
          lighten4: '#f7f6ff', // 100
          lighten3: '#e9e5fd', // 200
          lighten2: '#b7b0ea', // 300
          lighten1: '#7667c1', // 400
        },
        purple: {
          base: '#3c3087', // 500
          lighten4: '#f7f6ff', // 100
          lighten3: '#e9e5fd', // 200
          lighten2: '#b7b0ea', // 300
          lighten1: '#7667c1', // 400
        },
        green: {
          base: '#3fac49', // 300
          lighten2: '#ecf7ed', // 100
          lighten1: '#aad69b', // 200
        },
        success: {
          base: '#00613a', // 500
          lighten4: '#edfcf6', // 200
          lighten3: '#d7f7e8', // 200
          lighten2: '#b8e4d1', // 300
          lighten1: '#00b480', // 400
        },
        warning: {
          base: '#ea7c0e', // 400
          lighten3: '#fdf6e9', // 100
          lighten2: '#faebd2', // 200
          lighten1: '#fbdfb3', // 300
          darken1: '#a34007', // 500
        },
        error: {
          base: '#e40c18', // 400
          lighten3: '#fff5f7', // 100
          lighten2: '#ffe3e4', // 200
          lighten1: '#ffcbce', // 300
          darken1: '#af090c', // 500
        },
        grey: {
          base: '#757575', // 500
          lighten4: '#fafafa', // 100
          lighten3: '#f7f7f7', // 200
          lighten2: '#f0f0f0', // 300
          lighten1: '#e0e0e0', // 400
          darken1: '#424242', // 600
          darken2: '#202121', // 700
        },
      },
      dark: {
        primary: '#00acef',
        blue: '#00acef',
        info: '#00acef',
        grey: '#212121',
        secondary: '#1867c0',
        indigo: '#fff',
      },
    },
  },
})
